export const SET_EXCEL_DOWNLOAD = 'SET_EXCEL_DOWNLOAD';
export const RECURRING_DOWNLOAD = 'RECURRING_DOWNLOAD';
